import { render, staticRenderFns } from "./CarsCombinedView.vue?vue&type=template&id=1491dccb&lang=pug&"
import script from "./CarsCombinedView.vue?vue&type=script&lang=ts&"
export * from "./CarsCombinedView.vue?vue&type=script&lang=ts&"
import style0 from "./CarsCombinedView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VDivider,VTab,VTabItem,VTabs,VTabsItems})
